import React from "react";

const LEVERS = [
  { label: "Solar", amt: 5.2 },
  { label: "Power factor", amt: 1.1 },
  { label: "Demand right-sizing", amt: 2.2 },
  { label: "ToD shift", amt: 0.9 },
];

export function WaterfallChart({ show }) {
  const START = 28.4;
  const MAX = 30, top = 34, bottom = 292;
  const H = bottom - top;
  const y = (v) => bottom - (v / MAX) * H;

  let run = START;
  const cols = [{ label: "Today", from: 0, to: START, kind: "solid", text: "₹28.4L" }];
  LEVERS.forEach((l) => {
    cols.push({ label: l.label, from: run - l.amt, to: run, kind: "delta", text: `−₹${l.amt.toFixed(1)}L` });
    run -= l.amt;
  });
  cols.push({ label: "After", from: 0, to: run, kind: "solid", text: `₹${run.toFixed(1)}L` });

  const colW = 96, barW = 58, x0 = 4;
  const bx = (i) => x0 + i * colW + (colW - barW) / 2;
  const brX = 616, midY = (y(START) + y(19.0)) / 2;

  return (
    <svg viewBox="0 0 680 330" className="w-full h-auto" role="img" aria-label="Waterfall chart: annual bill stepping down from ₹28.4 lakh to ₹19.0 lakh through four savings levers" data-testid="journey-waterfall-chart">
      <defs>
        <linearGradient id="wzWfGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#00D4FF" />
          <stop offset="1" stopColor="#21F59B" />
        </linearGradient>
      </defs>
      {cols.map((c, i) => {
        const style = {
          opacity: show ? 1 : 0,
          transform: show ? "none" : "translateY(-14px)",
          transition: `opacity .5s ease ${i * 0.18}s, transform .5s ease ${i * 0.18}s`,
        };
        return (
          <g key={c.label} style={style}>
            <rect
              x={bx(i)} y={y(c.to)} width={barW} height={Math.max(2, y(c.from) - y(c.to))}
              rx="4" fill={c.kind === "solid" ? "#0A2540" : "url(#wzWfGrad)"}
            />
            <text x={bx(i) + barW / 2} y={y(c.to) - 8} textAnchor="middle" fontSize="12.5" fontWeight="600"
              fill={c.kind === "solid" ? "#0A2540" : "#009e6f"}>{c.text}</text>
            <text x={bx(i) + barW / 2} y={bottom + 20} textAnchor="middle" fontSize="11" fill="#64748b">{c.label}</text>
            {i < cols.length - 1 && (
              <line x1={bx(i) + barW} y1={y(cols[i + 1].to)} x2={bx(i + 1)} y2={y(cols[i + 1].to)}
                stroke="#94a3b8" strokeWidth="1.5" strokeDasharray="4 4" />
            )}
          </g>
        );
      })}
      <g style={{ opacity: show ? 1 : 0, transition: "opacity .6s ease 1.2s" }}>
        <line x1={brX} y1={y(START)} x2={brX} y2={y(19.0)} stroke="url(#wzWfGrad)" strokeWidth="3" />
        <line x1={brX - 7} y1={y(START)} x2={brX + 7} y2={y(START)} stroke="url(#wzWfGrad)" strokeWidth="3" />
        <line x1={brX - 7} y1={y(19.0)} x2={brX + 7} y2={y(19.0)} stroke="url(#wzWfGrad)" strokeWidth="3" />
        <text transform={`rotate(-90 ${brX + 26} ${midY})`} x={brX + 26} y={midY} textAnchor="middle" fontSize="14" fontWeight="700" fill="#009e6f">₹9.4L</text>
        <text transform={`rotate(-90 ${brX + 44} ${midY})`} x={brX + 44} y={midY} textAnchor="middle" fontSize="9.5" fill="#64748b">identified savings potential</text>
      </g>
    </svg>
  );
}
